/*
  Live-Kurse für die ganze Website (Okt 2026) – EINE Datenquelle.
  Hauptquelle: GPE-App („Live Gold Price Editor“) – derselbe Kurs, aus dem die Produktpreise berechnet werden
  (gelesen über die Section-Rendering-API: /?sections=ma-kurs-data, EUR je Gramm).
  Reserve 1: gold-api.com (Weltmarktpreis in EUR inkl. Live-Wechselkurs), Reserve 2: Kitco –
  nur wenn die App keinen Kurs liefert.
  Aktualisiert alle Elemente mit [data-ma-kurs] und meldet das Ereignis „ma:kurs“
  (detail: { spot: {au,ag,pt,pd} in EUR/g, factor(key), ab, at, source }).
  Abschläge + Intervall kommen aus window.MA_KURS_CFG (Theme-Einstellungen „Ankauf & Kurse“).
*/
(() => {
  const CFG = window.MA_KURS_CFG || { ab: {}, refresh: 60 };
  const OZ = 31.1034768;
  const SYM = { au: ['XAU', 'AU'], ag: ['XAG', 'AG'], pt: ['XPT', 'PT'], pd: ['XPD', 'PD'] };
  const fmt = n => n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const factor = key => key && CFG.ab[key] != null ? 1 - (+CFG.ab[key] / 100) : 1;

  async function fromGoldApi(sym) {
    const r = await fetch(`https://api.gold-api.com/price/${sym}/EUR`, { cache: 'no-store' });
    if (!r.ok) throw new Error('gold-api ' + r.status);
    const j = await r.json();
    if (!(j.price > 0)) throw new Error('gold-api leer');
    return { eurOz: j.price, at: j.updatedAt, source: 'gold-api.com' };
  }
  async function fromKitco(sym) {
    const r = await fetch(`https://proxy.kitco.com/getPM?symbol=${sym}&currency=EUR`, { cache: 'no-store' });
    if (!r.ok) throw new Error('kitco ' + r.status);
    const f = (await r.text()).trim().split(',');
    const mid = parseFloat(f[5]);
    if (!(mid > 0)) throw new Error('kitco leer');
    return { eurOz: mid, at: f[3], source: 'Kitco' };
  }

  async function fromApp() {
    const r = await fetch(`/?sections=ma-kurs-data&_=${Date.now()}`, { cache: 'no-store' });
    if (!r.ok) throw new Error('app ' + r.status);
    const html = (await r.json())['ma-kurs-data'] || '';
    const m = html.match(/<script[^>]*id="ma-kurs-data"[^>]*>([\s\S]*?)<\/script>/);
    const d = m ? JSON.parse(m[1]) : null;
    if (!d || !(d.au > 0)) throw new Error('app leer');
    return d;
  }

  let last = null;
  async function load() {
    try {
      const d = await fromApp();
      const spot = {}; ['au', 'ag', 'pt', 'pd'].forEach(k => { if (d[k] > 0) spot[k] = +d[k]; });
      last = { spot, factor, ab: CFG.ab, at: d.at ? new Date(d.at) : new Date(), source: 'GPE-App' };
      window.MAKurs = last; paint();
      document.dispatchEvent(new CustomEvent('ma:kurs', { detail: last }));
      return;
    } catch (e) { /* weiter mit Reserve-Quellen */ }
    const spot = {}; let at = null, source = null;
    await Promise.all(Object.entries(SYM).map(async ([m, [g, k]]) => {
      let d = null;
      try { d = await fromGoldApi(g); } catch (e) { try { d = await fromKitco(k); } catch (e2) { d = null; } }
      if (d) { spot[m] = d.eurOz / OZ; at = at || d.at; source = source || d.source; }
    }));
    if (!Object.keys(spot).length) return;
    last = { spot, factor, ab: CFG.ab, at: at ? new Date(at) : new Date(), source };
    window.MAKurs = last;
    paint();
    document.dispatchEvent(new CustomEvent('ma:kurs', { detail: last }));
  }

  function paint(scope) {
    if (!last) return;
    (scope || document).querySelectorAll('[data-ma-kurs]').forEach(el => {
      const s = last.spot[el.dataset.metal || 'au']; if (!(s > 0)) return;
      const v = s * (parseFloat(el.dataset.purity) || 1) * factor(el.dataset.key);
      el.textContent = (el.dataset.prefix || '') + fmt(v) + (el.dataset.suffix != null ? el.dataset.suffix : ' €/g');
    });
    const t = last.at.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
    document.querySelectorAll('[data-ma-kurs-zeit]').forEach(el => { el.textContent = t + ' Uhr'; });
  }

  window.MAKursPaint = paint;
  const start = () => { load(); setInterval(load, Math.max(30, +CFG.refresh || 60) * 1000); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
